module.exports = __webpack_public_path__ + "img/thank1.74939819.gif";